import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { CardContent, CardModule } from '@domains/home/card/card.component';
import { environment } from '@environment';
import { CompaniesRoutingEnum } from '@features/companies/companies-routing.enum';
import { EmployerRoutingEnum } from '@features/employer/employer-routing.enum';
import { FeaturesRoutingEnum } from '@features/features-routing.enum';
import { InternshipsRoutingEnum } from '@features/internships/internships-routing.enum';
import { JobsRoutingEnum } from '@features/jobs/jobs-routing.enum';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-home-b-employer',
  templateUrl: './home-b-employer.component.html',
  styleUrls: ['./home-b-employer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBEmployerComponent {
  contentEmployer: CardContent[] = [
    {
      title: "Je m'engage pour la jeunesse",
      img: `${environment.wizbiiImages}/home/employer-thumbnails/commited.jpg`,
      link: ['/', FeaturesRoutingEnum.Companies, CompaniesRoutingEnum.Register],
      trackEventAction: 'Mobilisation',
      trackEventLabel: 'Vignette',
    },
    {
      title: 'Je dépose une offre d’emploi ou de stage',
      img: `${environment.wizbiiImages}/home/employer-thumbnails/job.jpg`,
      dropdown: [
        {
          title: "Offre d'emploi",
          link: ['/', FeaturesRoutingEnum.Jobs, JobsRoutingEnum.Offer],
          trackEventAction: 'Dépot Offres',
        },
        {
          title: 'Offre de stage',
          link: ['/', FeaturesRoutingEnum.Internships, InternshipsRoutingEnum.Offer],
          trackEventAction: 'Dépot Stages',
        },
      ],
    },
    {
      title: 'Je bénéficie des aides',
      img: `${environment.wizbiiImages}/home/employer-thumbnails/employer-measures.jpg`,
      link: ['/', FeaturesRoutingEnum.Employers, EmployerRoutingEnum.Articles],
      trackEventAction: 'Info Mesures',
    },
    {
      title: 'Je m’engage dans le mentorat',
      img: `${environment.wizbiiImages}/home/employer-thumbnails/mentor.jpg`,
      link: ['/', FeaturesRoutingEnum.Mentoring],
      trackEventAction: 'Devenir Mentor',
    },
  ];

  get isMobile$(): Observable<boolean> {
    return this.breakpointService.isMobile$;
  }

  constructor(private readonly breakpointService: BreakpointsService) {}

  trackByItemTilte(_: number, item: CardContent): string {
    return item.title;
  }
}

@NgModule({
  imports: [CommonModule, CardModule],
  declarations: [HomeBEmployerComponent],
  exports: [HomeBEmployerComponent],
})
export class HomeBEmployerModule {}
